export default {
   layout: {
        zh: '中文简体',
        en: 'English',
        kr: '한국어',
        tc:'中文繁体',
        th:'泰语ภาษาไทย',
        vn:'Việt Nam'
    },
  footer: { desc: '' },
  menu: {
    home: 'หน้าแรก',
    node: 'โหนด',
    exchange: 'แลกเปลี่ยน',
    staking: 'สเตกกิ้ง',
    me: 'บัญชีของฉัน'
  },
  home: {
    ecological: 'โหนดนิเวศ',
    more: 'ดูเพิ่มเติม',
    genesis: 'โหนดเพชร',
    gold: 'โหนดทอง',
    onlyLeft: 'เหลือเพียง',
    coin: 'อัตราส่วนเหรียญ',
    subscription: 'ซื้อโหนด',
    application: 'สถานการณ์การใช้งานนิเวศ',
    desc1: 'แลกคะแนนห้างและชำระค่าสินค้า',
    desc2: 'สมัครโหนด、รายได้สเตกกิ้งและโหวตการปกครอง',
    desc3: 'แลกสินทรัพย์ทอง (แมปปิ้ง RWA)',
    desc4: 'แบ่งกำไรพ่อค้าและสิทธิประโยชน์หุ้น',
    desc5: 'ตั้งยอดค่าธรรมเนียมและแบ่งกำไรแพลตฟอร์ม',
    community: 'การปกครองชุมชน DAO และการโหวต',
    partners: 'พันธมิตร',
    contact: 'ติดต่อเรา',
    limited: 'จำนวนจำกัด',
    mat: 'ที่',
    lock: 'ปลดล็อกคลัง',
    sky: 'วัน'
  },
  node: {
    ecology: 'โหนดนิเวศ',
    meNode: 'โหนดของฉัน',
    genesis: 'โหนดเพชร',
    onlyLeft: 'เหลือเพียง',
    coin: 'อัตราส่วนเหรียญ',
    subscription: 'ซื้อโหนด',
    diamond: 'โหนดเพชร',
    bronze: 'โหนดทองแดง',
    revenue: 'ดูรายได้',
    gold: 'โหนดทอง',
    silver: 'โหนดเงิน',
    noNode: 'ยังไม่มีโหนด，สมัครทันที',
    totalCollection: 'รวมที่รับ',
    toBeClaimed: 'รอการรับ',
    claimed: 'รับ',
    totalRelease: 'รวมที่ปลดล็อก',
    released: 'ปลดล็อกแล้ว',
    toBeReleased: 'รอปลดล็อก',
    genesisReleased: 'ปลดล็อกโหนดเพชร',
    more: 'ลากลงเพื่อโหลดเพิ่มเติม',
    nodeSubscription: 'สมัครโหนด',
    receivedTo: 'รับเข้า',
    networkFee: 'ค่าธรรมเนียมเครือข่าย',
    confirmSubscription: 'ยืนยันการสมัคร',
    progress: 'ทำรายการอยู่',
    executionSuccessful: 'ดำเนินการสำเร็จ',
    at: 'ที่',
    view: 'ดูที่',
    releaseRecord: 'บันทึกการปลดล็อก',
    claimRecord: 'บันทึกการรับ',
    nonce: 'Nonce',
    claimIncome: 'รับรายได้',
    quantityClaimed: 'จำนวนที่รับ',
    pickup: 'สามารถรับได้',
    all: 'ทั้งหมด',
    confirmToReceive: 'ยืนยันการรับ',
          node0:'โหนดเพชร',
       node1:'โหนดแพลทินัม',
       node2:'โหนดทอง',
       node3:'โหนดมรกต',
       node4:'โหนดเงิน',
       node5:'โหนดทองแดง',

              release1:'สิ่งจูงใจสำหรับ KOL',
       release2:'การแจกเหรียญฟรีทั่วโลก',
       release3:'กลุ่มสภาพคล่อง',
       release4:'ทีมผู้ก่อตั้ง',
       release5:'กองทุนระบบนิเวศ',
       release6:'สถาบัน',
       release7:'โหนดทั่วโลก',
       release8:'กลุ่มการขุดระบบนิเวศ',
       release9:'กลุ่มการขุดแบบ Staking',
       

       success:'สำเร็จ',
       error:'ล้มเหลว',
       nocount:'โหนดนี้ขายหมดแล้ว'
  },
  exchange: {
    at: 'ที่',
    view: 'ดูที่',
    more: 'เพิ่มเติม',
    indicator: 'ตัวชี้วัด',
    market: 'แลกตามราคาตลาด',
    payment: 'ชำระเงิน',
    all: 'ทั้งหมด',
    received: 'ได้รับ',
    slippage: 'สลิปเปจ',
    minimum: 'จำนวนขั้นต่ำที่ได้รับ',
    cost: 'ค่าธรรมเนียมเครือข่าย',
    confirmExchange: 'ยืนยันการแลก',
    record: 'ประวัติ',
    completed: 'เสร็จสิ้น',
    error: 'ล้มเหลว',
    downMore: 'ลากลงเพื่อโหลดเพิ่มเติม',
    price: 'ราคา',
    progress: 'ทำรายการอยู่',
    wallet: 'กระเป๋าเงินที่เริ่มต้น',
    refuse: 'ปฏิเสธ',
    nodeSubscription: 'สมัครโหนด',
    executionSuccessful: 'ดำเนินการสำเร็จ',
    nonce: 'Nonce',
    confirm: 'ยืนยัน'
  },
  me: {
    assets: 'มูลค่าสินทรัพย์ทั้งหมด',
    recharge: 'เติมเงิน',
    transfer: 'โอนออก',
    record: 'ประวัติ'
  },
  recharge: {
    recharge: 'เติมเงิน',
    title: 'ที่อยู่นี้รองรับเฉพาะสินทรัพย์เกี่ยวกับ NEX',
    address: 'ที่อยู่รับเงิน',
    copy: 'คัดลอก',
    share: 'แชร์'
  },
  record: {
    record: 'บันทึก',
    all: 'ทั้งหมด',
    recharge: 'เติมเงิน',
    transfer: 'โอนออก',
    claimed: 'รับ'
  },
  transfer: {
    transfer: 'โอนออก',
    address: 'ที่อยู่โอนออก',
    transferCoin: 'โทเค็นโอนเงิน',
    pla: 'กรุณาใส่ที่อยู่โอนออก',
    network: 'เครือข่ายโอนเงิน',
    mainNetwork: 'เลือกเมนเน็ต',
    transferAmount: 'จำนวนเงินโอนออก',
    withdraw: 'ขั้นต่ำถอน 20',
    all: 'ทั้งหมด',
    balance: 'ยอดคงเหลือที่ใช้ได้',
    tips: 'ตรวจสอบที่อยู่และเครือข่ายโอนออกอย่างระมัดระวัง，เมื่อโอนแล้วไม่สามารถคืนได้',
    amountReceived: 'จำนวนที่เข้าบัญชี',
    free: 'ค่าธรรมเนียมเครือข่าย'
  }
};